module.exports = "../images/fishing-on-lake-home-2.jpg?v=49b2e6a";